import { useContext, useEffect, useState } from "react";
import KickoutLayout from "../Layout/KickoutLayout";
import { getOperationId } from "../../../../../api/logger-configuration";
import { ClientConfigurationContext } from "../../../../../context/ClientConfigurationContextProvider";

export default function TechnicalDifficulties() {
    const [operationId, setOperationId] = useState(null);
    const clientConfiguration = useContext(ClientConfigurationContext);

    useEffect(() => {
        getOperationId(async (res) => {
            try {
                const json = await res.json();
                console.log(json);
                if (clientConfiguration?.displayOperationId) {
                    setOperationId(json?.operationId);
                }
            } catch { }
        })
    }, []);

    return (
        <KickoutLayout
            header="Technical Difficulties"
            icon="icon-alert"
        >
            <div className="container">
                <div className="margin-top row" style={{ marginTop: "60px" }}>
                    <div className="hidden-sm col-md-3">
                        <img src="images/pose.png" alt="Decorative pose" />
                    </div>
                    <div className="col-sm-12 col-md-8">
                        <li className="alert-content" style={{ marginTop: "40px" }}>
                            <div className="h3">
                                We’re having some technical difficulties.
                            </div>
                            <p>
                                We’re sorry for the inconvenience. Please try again later.
                            </p>
                            {operationId && <p className="small-text">
                                Operation ID: <span>{operationId}</span>
                            </p>}
                        </li>
                    </div>
                </div>
            </div>
        </KickoutLayout>
    );
}
